import { useState } from "react";
import { resolveRange, type DateRangeValue } from "@/ui";

/**
 * 时间范围筛选的状态：相对范围（最近 24 小时之类）按"选定那一刻"解析，而不是每次渲染都取当前时间。
 * 否则 from、to 每次渲染都变，查询键跟着变，结果回来一渲染又发起新查询，页面一直停在"加载中"。
 * 页面在每次发起新查询的操作时调 refresh（点"查询"、改其他筛选），相对范围随之往前走，标签与实际查询一致；
 * 改范围本身已经会刷新。自定义的绝对范围不受"那一刻"影响。
 */
export function useRange(initial: DateRangeValue) {
  const [range, setRangeValue] = useState(initial);
  const [now, setNow] = useState(() => new Date());
  const setRange = (v: DateRangeValue) => {
    setRangeValue(v);
    setNow(new Date());
  };
  const span = resolveRange(range, now);
  return { range, setRange, span, refresh: () => setNow(new Date()) };
}
